'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = ".varta-text-expandable--expanded .varta-text-expandable__icon {\n  transform: rotate(180deg); }\n\n.varta-text-expandable__button {\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  outline: 0;\n  color: #1a497d;\n  fill: #1a497d;\n  padding: 0;\n  margin: 0 auto;\n  display: block;\n  font-weight: 200; }\n\n.varta-text-expandable__icon {\n  display: inline-block;\n  transition: transform 0.3s ease;\n  margin-left: 4px;\n  position: relative;\n  top: 10px; }\n";
styleInject_es(css_248z);
